module.exports = __webpack_public_path__ + "static/media/b.922ac263.m4a";